module.exports = __webpack_public_path__ + "static/media/cerisaie02.56fdb3c6.jpg";